import * as _ from 'lodash';

class AlertsHelper {

    constructor() {
        this.alertsProperty = 'alerts';
        this.alertsWrapper = '#flash-alerts';
        this.alertTemplate = $('#alert-template');
        this.removeDelay = 5000;
    }

    setUpListeners() {
        $(document).on('click', '.alert-dismiss', (event) => $(event.target).closest('.alert').remove());
    }

    delayAlerts() {
        let self = this;
        $.each($(this.alertsWrapper).children(), function (key, value) {
            if (!$(value).attr('id')) {
                setTimeout(function () {
                    $(value).remove();
                }, self.removeDelay);
            }
        });
    }

    handleAjaxEvent(response) {
        this.currentResponse = response;
        if (!this.containsAlert()) {
            return;
        }

        this.addAlerts();
    }

    containsAlert() {
        return _.has(this.currentResponse, `responseJSON.${this.alertsProperty}`);
    }

    addAlerts() {
        _.chain(this.currentResponse)
            .get(`responseJSON.${this.alertsProperty}`, {})
            .flatMap((messages, key) =>
                _.map(messages, message => this.alertTemplate.clone()
                    .removeAttr('id')
                    .addClass(`alert-${key}`)
                    .prepend(message)
                )
            )
            .forEach(alert => {
                alert.delay(this.removeDelay)
                    .queue(() => alert.remove());
                $(this.alertsWrapper).append(alert);
            })
            .value();
    }
}

export default AlertsHelper;



// WEBPACK FOOTER //
// ./assets/js/utils/alerts-helper.js